import React from "react";
import _ from "lodash";
import set from "@rill/set";
import submit from "submit-form";

import loadStripeCard from "../../../utils/stripe-card";
import SettingsNav from "../../../parts/settings-nav";
import CancelAccountModal from "../../../parts/modals/cancel-account";
import UpdatePaymentModal from "../../../parts/modals/update-payment";

import UpgradeConfirmationModal from "../../../parts/modals/upgrade-confirmation";
import { STRIPE, US_STATES, AU_STATES } from "../../../constants";
import StripeCardComponent from "../../../parts/StripeCardComponent";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";

const { PLANS } = STRIPE;

const FORM_ID = "billing-card-address-details";

class BillingDetails extends React.Component {
  constructor() {
    super();

    this.state = {
      editCreditInfo: false,
      countrySelected: _.get(
        this.context,
        "locals.activeUserToRequest.stripe.card.addressCountry",
        "locals.activeUserToRequest.country"
      ),
      stateSelected: _.get(
        this.context,
        "locals.activeUserToRequest.stripe.card.addressState",
        null
      ),
    };

    this.handleCreditToggle = this.handleCreditToggle.bind(this);
  }

  componentDidMount() {
    loadStripeCard(FORM_ID, this.stripeTokenHandler);
  }

  stripeTokenHandler(res) {
    submit("/actions/billing/update/source", {
      method: "POST",
      body: {
        source: loadStripeCard.getSourceValues(),
        stripeToken: res,
      },
    });
  }

  handleCreditToggle() {
    this.setState({ editCreditInfo: !this.state.editCreditInfo }, () => {
      loadStripeCard(FORM_ID, this.stripeTokenHandler);
    });
  }

  handleCountrySelect(e) {
    this.setState({ countrySelected: e.target.value });
  }
  handleStateSelect(e) {
    this.setState({ stateSelected: e.target.value });
  }

  render() {
    const { locals, req } = this.context;
    const {
      activeUser,
      organizationOwner,
      getCountryName,
      countries: countryOptions,
    } = locals;
    const userIsCoach = activeUser.permissions.includes("coach");
    const card =
      (!activeUser.organizationId && !organizationOwner) || !userIsCoach
        ? _.get(activeUser, "stripe.card", {})
        : _.get(organizationOwner, "stripe.card", {});
    const cardType = _.chain(activeUser)
      .get("stripe.card.brand", "")
      .replace(" ", "-")
      .lowerCase()
      .value();
    const {
      addressLine1,
      addressLine2,
      addressCity,
      addressZip,
      addressCountry,
      addressState,
    } = card ? card : {};
    const addressLine2Render = addressLine2 === null ? "" : addressLine2;

    return (
      <form method="POST" action="/actions/billing/update/source" id={FORM_ID}>
        <div className="Main Settings-Billing">
          <SettingsNav />

          <div className="Content">
            <div className="frame alt">
              <div className="columns">
                {_.isEmpty(card) ? (
                  <div>
                    <div className="column" data-col="1/2">
                      <div className="label" htmlFor="card-element">
                        Credit card information
                      </div>
                      <StripeCardComponent />
                    </div>

                    <div className="column" data-col="1/2" />

                    <div className="column" data-col="1/2" />
                  </div>
                ) : (
                  <div>
                    {(!this.state.editCreditInfo ||
                      req.query.closeEditCredit) && (
                      <div>
                        <div className="column" data-col="1/1">
                          <div className="label">Your Payment Details</div>
                        </div>

                        <div>
                          <div className="column" data-col="1/2">
                            <div className="payment-details">
                              <div>
                                <div
                                  className="cc-brand"
                                  style={{
                                    WebkitMask: `url(/img/${cardType}-icon.svg) no-repeat center`,
                                    mask: `url(/img/${cardType}-icon.svg) no-repeat center`,
                                  }}
                                />
                                <b>{`**** **** **** ${card.lastFour}`}</b>
                              </div>
                              <a
                                className="button outline"
                                href=""
                                onClick={this.handleCreditToggle}
                              >
                                Change Card
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {this.state.editCreditInfo && !req.query.closeEditCredit && (
                  <div>
                    <div className="column" data-col="1/2">
                      <div className="label" htmlFor="card-element">
                        Credit card information
                      </div>
                      <StripeCardComponent />
                    </div>

                    <div className="column" data-col="1/2" />
                  </div>
                )}

                <hr />

                <div className="column" data-col="1/2">
                  <div className="label">Billing Address</div>
                  <input
                    className="text-input"
                    name="source[address_line1]"
                    type="text"
                    placeholder="Address Line 1"
                    defaultValue={addressLine1}
                  />
                </div>
                <div className="column" data-col="1/2"></div>

                <div className="column" data-col="1/2">
                  <input
                    className="text-input"
                    name="source[address_line2]"
                    type="text"
                    placeholder="Address Line 2"
                    defaultValue={addressLine2Render}
                  />
                </div>
                <div className="column" data-col="1/2"></div>
                <div className="column" data-col="1/2">
                  <div className="column" data-col="1/2">
                    <input
                      className="text-input"
                      name="source[address_city]"
                      type="text"
                      placeholder="City"
                      defaultValue={addressCity}
                    />
                  </div>

                  {this.state.countrySelected === "CA" && (
                    <div className="column" data-col="1/4">
                      <select
                        className="select-input"
                        name="source[address_state]"
                        placeholder="Province"
                        value={this.state.stateSelected}
                        onChange={(e) => this.handleStateSelect(e)}
                      >
                        <option disabled value="">
                          Province
                        </option>
                        <option value="AB">Alberta</option>
                        <option value="BC">British Columbia</option>
                        <option value="MB">Manitoba</option>
                        <option value="NB">New Brunswick</option>
                        <option value="NL">Newfoundland and Labrador</option>
                        <option value="NS">Nova Scotia</option>
                        <option value="ON">Ontario</option>
                        <option value="PE">Prince Edward Island</option>
                        <option value="QC">Quebec</option>
                        <option value="SK">Saskatchewan</option>
                        <option value="NT">Northwest Territories</option>
                        <option value="NU">Nunavut</option>
                        <option value="YT">Yukon</option>
                      </select>
                    </div>
                  )}

                  {this.state.countrySelected === "US" && (
                    <div className="column" data-col="1/4">
                      <select
                        className="select-input"
                        type="text"
                        name="source[address_state]"
                        value={this.state.stateSelected}
                        onChange={(e) => this.handleStateSelect(e)}
                      >
                        <option disabled value="">
                          State
                        </option>
                        {US_STATES.map((state) => (
                          <option value={state.abbreviation}>
                            {state.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                </div>
                <div className="column" data-col="1/2" />

                {this.state.countrySelected === "AU" && (
                  <div className="column" data-col="1/4">
                    <select
                      className="select-input"
                      type="text"
                      name="source[address_state]"
                      value={this.state.stateSelected}
                      onChange={(e) => this.handleStateSelect(e)}
                    >
                      <option disabled value="">
                        State
                      </option>
                      {AU_STATES.map((state) => (
                        <option value={state.abbreviation}>{state.name}</option>
                      ))}
                    </select>
                  </div>
                )}

                {["AU", "CA", "US"].indexOf(this.state.countrySelected) ==
                  -1 && (
                  <div className="column" data-col="1/4">
                    <input
                      className="select-input"
                      name="source[address_state]"
                      type="text"
                      placeholder="State"
                      value={this.state.stateSelected}
                      onChange={(e) => this.handleStateSelect(e)}
                    />
                  </div>
                )}

                <div className="column" data-col="1/4">
                  <input
                    className="text-input"
                    name="source[address_zip]"
                    type="text"
                    placeholder={
                      this.state.countrySelected === "US"
                        ? "Zip Code"
                        : "Postal Code"
                    }
                    defaultValue={addressZip}
                  />
                </div>

                <div className="column" data-col="1/1">
                  <select
                    required
                    name="source[address_country]"
                    className="select-input"
                    value={
                      this.state.countrySelected
                        ? this.state.countrySelected
                        : _.get(activeUser, "country", "")
                    }
                    onChange={(e) => this.handleCountrySelect(e)}
                  >
                    <option hidden disabled value="">
                      Location
                    </option>
                    {_.map(countryOptions, (code) => {
                      return (
                        <option key={code} value={code}>
                          {getCountryName(code)}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className="column" data-col="1/1">
                  <button type="submit" className="button-input">
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

const Billing = (app) => {
  app.get(
    "/billing",
    set("heading", "Billing"),
    ({ res, req, locals, session }) => {
      const { query } = req;

      if (locals.activeUser.coach) {
        res.redirect("/logout");
      }
      // Redirect to upgrade page if user is on free trial
      const userIsCoach = locals.activeUser.permissions.includes("coach");
      const plan =
        (!locals.activeUser.organizationId && !locals.organizationOwner) ||
        !userIsCoach
          ? _.get(locals.activeUser, "stripe.plan", false)
          : _.get(locals.organizationOwner, "stripe.plan", false);

      if (
        plan == PLANS.LAUNCH.trial ||
        plan == PLANS.V2.trial ||
        locals.activeUser.cancelled
      ) {
        return res.redirect("/upgrade-1");
      }

      const modal = _.get(query, "modal", {});
      locals.modal = {
        cancel: <CancelAccountModal />,
        "update-payment": <UpdatePaymentModal />,
        "upgrade-confirmation": <UpgradeConfirmationModal />,
        "activity-feed": <ActivityDrawer />,
      }[modal.type];

      res.body = (
        <BillingDetails
          activeUser={locals.activeUser}
          showCard={query.action == "updateCard" ? true : false}
        />
      );
    }
  );
};

export default Billing;
